import Store from '../Store';

const ProductsOverviewStore = new Store('supplier/allproducts');

export default ProductsOverviewStore;